import { CrudDataGridProps } from "src/components/common/dataGrid/crud/CrudDataGrid";
import { useAsyncFetch } from "src/utils/async/asyncFetch.ts";
import { ControlledAsyncCrudDataGrid } from "./ControlledAsyncCrudDataGrid";

export interface AsyncCrudDataGridProps<RowData extends object>
	extends Omit<CrudDataGridProps<RowData>, "rows" | "refreshData"> {
	fetchData: () => Promise<RowData[]>;
}

export const AsyncCrudDataGrid = <RowData extends object>({
	fetchData,
	...other
}: AsyncCrudDataGridProps<RowData>) => {
	const [asyncRows, refresh] = useAsyncFetch(fetchData);
	return <ControlledAsyncCrudDataGrid rowsAsync={asyncRows} refreshData={refresh} {...other} />;
};
